/* =====================================================================
 * RIGHT DOSE - SPEED OPTIMIZED BUNDLE - Combined JS
 * Merged: price-badges.js + marquee-slider.js + tiny-img-link-preloader.js
 * Removed: custom.js (empty), menu-icons.js (no-op)
 * ===================================================================== */


/* ====================================================================
 * 1) PRICE BADGE INJECTOR
 *    Moves "Save AED X" label from top-left of product cards
 *    to inline with the price (next to "Was AED X")
 * ==================================================================== */
(function() {
  'use strict';

  function attachSaveBadges() {
    var items = document.querySelectorAll('.product-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.getAttribute('data-save-attached')) continue;

      var saleLabel = item.querySelector('.product-item__label-list .product-label--on-sale');
      var priceList = item.querySelector('.product-item__price-list');

      if (priceList && saleLabel && !priceList.querySelector('.price--save')) {
        var saveSpan = document.createElement('span');
        saveSpan.className = 'price price--save';
        saveSpan.innerHTML = saleLabel.innerHTML;
        priceList.appendChild(saveSpan);
        item.setAttribute('data-save-attached', '1');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSaveBadges);
  } else {
    attachSaveBadges();
  }

  document.addEventListener('shopify:section:load', attachSaveBadges);
  document.addEventListener('shopify:section:reorder', attachSaveBadges);
  document.addEventListener('page:loaded', attachSaveBadges);

  var observerTimeout;
  var observer = new MutationObserver(function(mutations) {
    var hasNewNodes = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        hasNewNodes = true;
        break;
      }
    }
    if (hasNewNodes) {
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(attachSaveBadges, 150);
    }
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();


/* ====================================================================
 * 2) MARQUEE SLIDER - Clone products for seamless loop
 * ==================================================================== */
(function() {
  'use strict';

  function cloneProducts() {
    var scrollers = document.querySelectorAll('.featured-collection .product-list--scroller');
    for (var i = 0; i < scrollers.length; i++) {
      var list = scrollers[i];
      if (list.dataset.marqueeCloned) continue;

      var items = list.children;
      if (items.length === 0) continue;

      var originals = [];
      for (var j = 0; j < items.length; j++) {
        originals.push(items[j]);
      }

      for (var k = 0; k < originals.length; k++) {
        var clone = originals[k].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-marquee-clone', '1');
        var clonedWithId = clone.querySelectorAll('[id]');
        for (var m = 0; m < clonedWithId.length; m++) {
          clonedWithId[m].removeAttribute('id');
        }
        if (clone.id) clone.removeAttribute('id');
        list.appendChild(clone);
      }

      list.dataset.marqueeCloned = '1';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cloneProducts);
  } else {
    cloneProducts();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(cloneProducts, 100);
  });
  document.addEventListener('shopify:section:reorder', function() {
    setTimeout(cloneProducts, 100);
  });
})();


/* ====================================================================
 * 3) INSTANT LINK PRELOADER (minified) - prefetches links on hover/touch
 *    Wrapped in IIFE to prevent variable collisions in bundle.
 * ==================================================================== */
(function() {
  'use strict';
  let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);if("/cart" == t.pathname || t.pathname.startsWith("/cart/"))return;return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}
})();
